import React from 'react';
import ProtectedRoute from './protected';
import AttendancePage from '../pages/attendance-management';

export const AttendanceRoutes = [
  <ProtectedRoute exact path='/attendance' component={AttendancePage} />,
  // <ProtectedRoute exact path='/attendance/schedule/view/:ref' component={AttendanceScheduleViewPage} />,
];